angular.module("acl.core.conditionalCriteriaSelector", [
  "templates-visualizer",
  "acl.common.input",
  "acl.common.filters",
  "acl.common.aclUiDatepicker",
  "ui.bootstrap",
  "ui.select",
]);
